import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';

import AvatarUpload from 'components/AvatarUpload';

import {signAgreementUserInternalAvatar} from 'sdk/agreementUsers';
import {
  MODALS,
  fetchAgreementUser,
  verifyAgreementUserInternalAvatarUpload,
  REFETCH_AVATARS_DELAY
} from 'ducks/agreementUsers';
import {
  requiresPermission,
  selectCurrentUserPermissions,
  PERMISSIONS
} from 'ducks/auth';
import {uploadFile} from 'ducks/files';
import {storeDataInModal} from 'ducks/modals';
import {composeActions, delayedAction} from 'ducks/common';
import {fetchBooking} from 'ducks/bookings';

import {headOption} from 'utils/common';
import {hasEntityPermission} from 'utils/permissions';

import './styles.css';

class AgreementUserAvatar extends React.Component<any> {
  state = {
    wrongFormat: false
  };

  onFileDrop = files => {
    if (_.isEmpty(files)) {
      return this.setState({wrongFormat: true});
    }

    const {bookingId, locationRef, agreementUser} = this.props;
    const agreementUserId = agreementUser.id;

    const file = headOption(files);

    const signData = {
      filename: file.name,
      fileType: file.type,
      location: locationRef,
      agreementUserId
    };

    const finishUploadingAction = () =>
      delayedAction({
        delay: REFETCH_AVATARS_DELAY,
        action: () =>
          composeActions([
            () =>
              fetchAgreementUser({agreementUserId}, [
                agreementUser =>
                  storeDataInModal({
                    modalName: MODALS.AGREEMENT_USER_INFO,
                    data: {
                      agreementUser
                    }
                  })
              ]),
            () => fetchBooking({locationRef, bookingId})
          ])
      });

    const storeIdentifierAction = identifier =>
      verifyAgreementUserInternalAvatarUpload({
        identifier,
        agreementUserId
      });

    this.setState({wrongFormat: false}, () =>
      this.props.uploadFile({
        file,
        signSdk: signAgreementUserInternalAvatar,
        signData,
        finishUploadingAction,
        storeIdentifierAction
      })
    );
  };

  onDropzoneInteraction = () =>
    this.props.requiresPermission({
      locationRef: this.props.locationRef,
      permission: PERMISSIONS.EDIT_MEMBER_INFORMATION
    });

  render() {
    const {wrongFormat} = this.state;
    const {agreementUser, userPermissions, locationRef} = this.props;

    return (
      <AvatarUpload
        user={agreementUser}
        onFileDrop={this.onFileDrop}
        disableClick={
          !hasEntityPermission({
            userPermissions,
            locationRef,
            permission: PERMISSIONS.EDIT_MEMBER_INFORMATION
          })
        }
        onFileDrag={this.onDropzoneInteraction}
        wrongFormat={wrongFormat}
      />
    );
  }
}

const mapStateToProps = state => ({
  userPermissions: selectCurrentUserPermissions(state)
});
const mapDispatchToProps = {uploadFile, requiresPermission};

export default connect(mapStateToProps, mapDispatchToProps)(
  AgreementUserAvatar
);
